import React from 'react';
import {connect} from 'react-redux';
import {worldEnum} from '../../Page/SelfCarePage/Constant';
import CellularPackage from './selfCarePackages/Cellular/CellularPackage';
import TvPackage from './selfCarePackages/Tv/TvPackage';
import InternetPackage from './selfCarePackages/Internet/InternetPackage';
import EnergyPackage from './selfCarePackages/Energy/EnergyPackage';
import {setSelectedSubscriber} from '../../Page/SelfCarePage/SelfCareSlice';
import {isMobile} from 'react-device-detect';

const SelfCarePackagesMain = (props) => {
  const packageImage = isMobile ? props.iContent?.packageImageMobile.value : props.iContent?.packageImageDesktop.value;
  let getCurrentPackage = () => {
    switch (worldEnum[props.worldType]) {
      case worldEnum.Main:
        if (props.isOtpAuthenticated) {
          return <CellularPackage iContent={props.iContent} />;
        }
        break;
      case worldEnum.Cellular:
        return <CellularPackage iContent={props.iContent} />;
      case worldEnum.TV:
        return <TvPackage iContent={props.iContent} packageImage={packageImage} />;
      case worldEnum.Internet:
        return <InternetPackage iContent={props.iContent} />;
      case worldEnum.Energy:
        if (props.selectedSubscriber) return <EnergyPackage iContent={props.iContent} packageImage={packageImage} />;
        else break;
      default:
        break;
    }
  };

  const selfCarePackage = getCurrentPackage();
  return <>{selfCarePackage && <div className='selfcare-package-details-block'>{selfCarePackage}</div>}</>;
};

const mapStateToProps = (state) => ({
  worldType: state.selfcarePage.epiData.worldType,
  selectedSubscriber: state.selfcarePage.selectedSubscriber,
  isOtpAuthenticated: state.authentication.loginData.isOtpAuthenticated,
  subscribersByProduct: state.selfcarePage.subscribersByProduct,
  isFetchData: state.selfcarePage.isFetchData,
});

const mapDispatchToProps = {setSelectedSubscriber};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCarePackagesMain);
